import Vue from 'vue'
import VueRouter from 'vue-router'

import auth from 'auth'
import { event } from 'utils'
import updateMetaData from 'utils/meta-data-updator'
import { startPageLoader, stopPageLoader } from 'utils/page-loader'

/*  Routes Lazy Loading
    https://router.vuejs.org/en/advanced/lazy-loading.html
*/
const DebugInfo = () => import('components/DebugInfo')
const Login = () => import('components/Login')
const LogOut = () => import('components/pages/logout/LogOut')
const IframePlayer = () => import('components/pages/iframe-player/IframePlayer')
const IframeEmbedPlayer = () => import('components/pages/embed-player/IframeEmbedPlayer')
const PodcasterRegister = () => import('components/PodcasterRegister')
const ResetPassword = () => import('components/ResetPassword')
const Podcast = () => import('components/Podcast')
const Job = () => import('components/pages/job/Job')
const Episode = () => import('components/Episode')
const Home = () => import('components/pages/home/Home')
const Listen = () => import('components/pages/listen/Listen')
const Categories = () => import('components/pages/listen/categories/Categories')
const PodcastMigrationDocument = () => import('components/podcaster/PodcastMigrationDocument')
const About = () => import('components/pages/about/About')
const BroadcastToPodcast = () => import('components/pages/broadcastToPodcast/BroadcastToPodcast')
const Advertisers = () => import('components/pages/advertisers/Advertisers')
const BecomePodcaster = () => import('components/pages/become-podcaster/BecomePodcaster')
const Creator = () => import('components/pages/creator/Creator')
const SubmitPodcast = () => import('components/pages/submit-podcast/SubmitPodcast')
const Career = () => import('components/pages/career/Career')
const News = () => import('components/pages/news/News')
const HelpPages = () => import('components/pages/helpPages/HelpPages')
const Termsconditions = () => import('components/pages/termsconditions/Termsandconditions')
const AdminAccount = () => import('components/AdminAccount')
const AdminMyAccount = () => import('components/admin/MyAccount')
const AdminCategoriesParent = () => import('components/admin/CategoriesParent')
const AdminNotificationsParent = () => import('components/admin/NotificationsParent')
const AdminPodcastsParent = () => import('components/admin/PodcastsParent')
const AdminUsersParent = () => import('components/admin/UsersParent')
const AdminStats = () => import('components/admin/Stats')
const AdminCareer = () => import('components/pages/admin/career/AdminCareer')
const AdminCareerAdd = () => import('components/pages/admin/career/careerAdd/AdminCareerAdd')
const ListenerAccount = () => import('components/ListenerAccount')
const ListenerSaved = () => import('components/listener/ListenerSaved')
const ListenerShows = () => import('components/listener/ListenerShows')
const PodcasterAccount = () => import('components/PodcasterAccount')
const PodcasterDashboard = () => import('components/podcaster/Dashboard')
const PodcasterPayments = () => import('components/podcaster/payments/PaymentsDashboard')
const PodcasterPodcastsParent = () => import('components/podcaster/PodcastsParent')
const PodcasterMyAccount = () => import('components/podcaster/MyAccount')
const PodcasterStats = () => import('components/podcaster/Stats')
const PodcasterMigrate = () => import('components/podcaster/PodcastsImport')
const PodcasterSubmit = () => import('components/podcaster/PodcastSubmit')
const AdvertiserAccount = () => import('components/AdvertiserAccount')
const AdvertiserDashboard = () => import('components/advertiser/Dashboard')
const AdvertiserAdsParent = () => import('components/advertiser/AdsParent')
const AdvertiserMyAccount = () => import('components/advertiser/MyAccount')
const AdvertiserStats = () => import('components/advertiser/Stats')
const PrivacyPolicy = () => import('components/pages/privacypolicy/PrivacyPolicy')
const Network = () => import('components/network-stations/NetworkPage')
const Station = () => import('components/network-stations/StationPage')
const GhostPage = () => import('components/pages/ghostCms/ghostPage/GhostPage')
const GhostPost = () => import('components/pages/ghostCms/ghostPost/GhostPost')
const GhostBlog = () => import('components/pages/ghostCms/ghostBlog/GhostBlog')
const NetworksAndStationsLandingPage = () => import('components/network-stations/LandingPage')

Vue.use(VueRouter)

const router = new VueRouter({
  base: process.env.PUBLIC_PATH,
  linkActiveClass: 'active',
  mode: 'history',
  routes: [
    {
      path: '/dev/debug-info',
      name: 'debug-info',
      component: DebugInfo,
    },
    {
      path: '/privacy-policy',
      name: 'PrivacyPolicy',
      component: PrivacyPolicy,
    },
    {
      path: '',
      name: 'Home',
      component: Home,
    },
    {
      path: '/listen',
      name: 'Listen',
      component: Listen,
    },
    {
      path: '/listen/categories/:category/:language',
      name: 'Categories',
      component: Categories,
    },
    {
      path: '/podcasters',
      name: 'Podcasters',
      component: Login,
    },
    {
      path: '/advertisers',
      name: 'Advertisers',
      component: Login,
    },
    {
      path: '/register',
      name: 'PodcasterRegister',
      component: PodcasterRegister,
    },
    {
      path: '/reset_password',
      name: 'ResetPassword',
      component: ResetPassword,
    },
    {
      path: '/terms',
      name: 'TermsAndConditions',
      component: Termsconditions,
    },
    {
      path: '/about',
      name: 'About',
      component: About,
    },
    {
      path: '/b2p',
      name: 'BroadcastToPodcast',
      component: BroadcastToPodcast,
    },
    {
      path: '/creator',
      name: 'Creator',
      component: Creator,
    },
    {
      path: '/submit_podcast',
      name: 'SubmitPodcast',
      component: SubmitPodcast,
    },
    {
      path: '/become_advertiser',
      name: 'BecomeAdvertiser',
      component: Advertisers,
    },
    {
      path: '/news',
      name: 'News',
      component: News,
    },
    {
      path: '/help',
      name: 'HelpPages',
      component: HelpPages,
    },
    {
      path: '/careers',
      name: 'Career',
      component: Career,
    },
    {
      path: '/careers/:jobId',
      name: 'Job',
      component: Job,
      children: [
        {
          path: ':action',
          component: Job,
        },
      ],
    },
    {
      path: '/podcast/:slug',
      name: 'Podcast',
      component: Podcast,
      children: [
        {
          path: ':action',
          component: Podcast,
        },
      ],
    },
    {
      path: '/episode/:seoURL/:episodeId',
      name: 'Episode',
      component: Episode,
      children: [
        {
          path: ':action',
          component: Episode,
        },
      ],
    },
    {
      path: '/embed/player/:episodeId',
      name: 'iframe-player',
      component: IframePlayer,
    },
    {
      path: '/embed/embedplayer/:episodeId',
      name: 'embedplayer',
      component: IframeEmbedPlayer,
    },
    {
      path: '/embed/embedarchiveplayer/:podcastId',
      name: 'embedarchiveplayer',
      component: IframeEmbedPlayer,
    },
    {
      path: '/admin',
      name: 'AdminAccount',
      component: AdminAccount,
      meta: { requiresAuth: true, authType: 'admin' }, // authentication check
      children: [
        {
          path: 'my_account',
          name: 'AdminMyAccount',
          component: AdminMyAccount,
        },
        {
          path: 'stats',
          name: 'AdminStats',
          component: AdminStats,
        },
        {
          path: 'categories',
          name: 'AdminCategories',
          component: AdminCategoriesParent,
        },
        {
          path: 'notifications',
          name: 'AdminNotifications',
          component: AdminNotificationsParent,
        },
        {
          path: 'categories/:action/:recordId',
          name: 'AdminCategoriesAdd',
          component: AdminCategoriesParent,
        },
        {
          path: 'podcasts',
          name: 'AdminPodcastsParent',
          redirect: '/admin/podcasts/list',
          component: AdminPodcastsParent,
          children: [
            {
              path: ':section',
              name: 'AdminPodcastsList',
              component: AdminPodcastsParent,
              children: [
                {
                  path: 'by_category/:categoryId',
                  name: 'AdminPodcastsListByCategory',
                  component: AdminPodcastsParent,
                },
                {
                  path: 'by_author/:authorId',
                  name: 'AdminPodcastsListByAuthor',
                  component: AdminPodcastsParent,
                },
                {
                  path: 'by_podcast/:podcastId',
                  name: 'AdminEpisodesPodcastId',
                  component: AdminPodcastsParent,
                },
                {
                  path: ':action/:recordId',
                  name: 'AdminPodcastsListAdd',
                  component: AdminPodcastsParent,
                },
                {
                  path: ':action/:recordId',
                  name: 'AdminPodcastsListStats',
                  component: AdminPodcastsParent,
                },
              ],
            },
          ],
        },
        {
          path: 'network/:action/:id?',
          name: 'AdminNetworkList',
          component: AdminPodcastsParent,
        },
        {
          path: 'station/:action/:id?',
          name: 'AdminStationList',
          component: AdminPodcastsParent,
        },
        {
          path: 'users',
          name: 'AdminUsersParent',
          component: AdminUsersParent,
          redirect: '/admin/users/list',
          children: [
            {
              path: ':section',
              name: 'AdminUsersList',
              component: AdminUsersParent,
              children: [
                {
                  path: 'by_author/:authorId',
                  name: 'AdminUsersListByAuthor',
                  component: AdminPodcastsParent,
                },
                {
                  path: ':action/:recordId',
                  name: 'AdminUsersAdd',
                  component: AdminUsersParent,
                },
              ],
            },
          ],
        },
        {
          path: 'career',
          name: 'AdminCareer',
          component: AdminCareer,
        },
        {
          path: '/career/:action/:recordId',
          name: 'AdminCareerAdd',
          component: AdminCareerAdd,
        },
      ],
    },
    {
      path: '/listener',
      name: 'ListenerAccount',
      component: ListenerAccount,
      meta: { requiresAuth: true, authType: 'podcaster' }, // authentication check
      children: [
        {
          path: 'shows',
          name: 'ListenerShows',
          component: ListenerShows,
        },
        {
          path: 'saved',
          name: 'ListenerSaved',
          component: ListenerSaved,
        },
      ],
    },
    {
      path: '/become_podcaster',
      name: 'BecomePodcaster',
      component: BecomePodcaster,
      meta: { requiresAuth: true, authType: 'podcaster' }, // authentication check
    },
    {
      path: '/podcaster',
      name: 'PodcasterAccount',
      component: PodcasterAccount,
      meta: { requiresAuth: true, authType: 'podcaster' }, // authentication check
      children: [
        {
          path: 'dashboard',
          name: 'PodcasterDashboard',
          component: PodcasterDashboard,
        },
        {
          path: 'payments',
          name: 'PodcasterPayments',
          component: PodcasterPayments,
        },
        {
          path: 'submit',
          name: 'PodcasterSubmitPodcast',
          component: PodcasterSubmit,
        },
        {
          path: 'migrate',
          name: 'PodcasterMigratePodcast',
          component: PodcasterMigrate,
        },
        {
          path: 'migrate/help',
          name: 'PodcastMigrationHelp',
          component: PodcastMigrationDocument,
        },
        {
          path: 'my_account',
          name: 'PodcasterMyAccount',
          component: PodcasterMyAccount,
        },
        {
          path: 'stats',
          name: 'PodcasterStats',
          component: PodcasterStats,
        },
        {
          path: 'podcasts',
          name: 'PodcasterPodcastsParent',
          redirect: '/podcaster/podcasts/list',
          component: PodcasterPodcastsParent,
          children: [
            {
              path: ':section',
              name: 'PodcasterPodcastList',
              component: PodcasterPodcastsParent,
              children: [
                {
                  path: 'by_podcast/:podcastId',
                  name: 'PodcasterEpisodesPodcastId',
                  component: PodcasterPodcastsParent,
                },
                {
                  path: ':change_status',
                  name: 'PodcasterPodcastListStatus',
                  component: PodcasterPodcastsParent,
                },
                {
                  path: ':action/:recordId',
                  name: 'PodcasterPodcastListAdd',
                  component: PodcasterPodcastsParent,
                },
              ],
            },
          ],
        },
        {
          path: 'broadcasts/:section/:action?/:recordId?',
          name: 'PodcasterBroadcasts',
          component: PodcasterPodcastsParent,
        },
      ],
    },
    {
      path: '/advertiser',
      name: 'AdvertiserAccount',
      component: AdvertiserAccount,
      meta: { requiresAuth: true, authType: 'advertiser' }, // authentication check
      children: [
        {
          path: 'dashboard',
          name: 'AdvertiserDashboard',
          component: AdvertiserDashboard,
        },
        {
          path: 'my_account',
          name: 'AdvertiserMyAccount',
          component: AdvertiserMyAccount,
        },
        {
          path: 'stats',
          name: 'AdvertiserStats',
          component: AdvertiserStats,
        },
        {
          path: 'ads',
          name: 'AdvertiserAdsParent',
          redirect: '/advertiser/ads/list',
          component: AdvertiserAdsParent,
          children: [
            {
              path: ':section',
              name: 'AdvertiserAdsList',
              component: AdvertiserAdsParent,
            },
          ],
        },
      ],
    },
    {
      path: '/network/:slug',
      name: 'Network',
      component: Network,
    },
    {
      path: '/station/:slug',
      name: 'Station',
      component: Station,
    },
    {
      path: '/radio-networks',
      name: 'NetworksAndStationsLandingPage',
      component: NetworksAndStationsLandingPage,
    },
    {
      path: '/page/:slug',
      name: 'GhostPage',
      component: GhostPage,
    },
    {
      path: '/blog',
      name: 'GhostBlog',
      component: GhostBlog,
    },
    {
      path: '/logout',
      name: 'logout',
      component: LogOut,
    },
    {
      path: '/blog/:slug',
      name: 'GhostPost',
      component: GhostPost,
    },
    { path: '*', redirect: '/' },
  ],
})

router.beforeResolve((to, from, next) => {
  if (to.name) {
    startPageLoader()
  }

  next()
})

router.afterEach(() => {
  stopPageLoader()
})

/*  Global Router Function
    Checks if section require authentication and what type of user level
*/
router.beforeEach((to, from, next) => {
  if ($('.navbar-collapse').hasClass('in')) {
    $('.navbar-toggle').trigger('click')
  }

  $('#afripods-content').animate({ scrollTop: 0 }, 0)

  // save last url in the eventBus
  event.lastURL = from.fullPath

  const { authType } = to.matched[0].meta
  let redirectToHome = false

  if (
    to.matched.some((record) => record.meta.requiresAuth) && // if the token is not valid or auth type is not matching set redirect to true
    !auth.checkAuthentication(authType)
  ) {
    redirectToHome = true
  }

  if (redirectToHome) return next({ name: 'Home' })

  // Update episode and podcast meta data
  updateMetaData(to)
    .then(() => next())
    .catch(() => next())
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js